import { Meta } from '@storybook/addon-docs';
import { TokensGrid } from '../../components/TokensGrid';
import { space } from '@rocketseat-ignite-ui/tokens';

<Meta title='Tokens/Spaces' />

# Space

<TokensGrid tokens={space} hasRemValue />
